// 后台工作状态不参与可输入判断；只有入口关闭/项目停用才改为只读。
export function projectConversationWritable({ workspaceEnabled, projectStatus }) {
  return workspaceEnabled === true && projectStatus === 'active'
}
export const projectGateActionable = payload => payload?.status === 'pending' && Boolean(payload.gate?.id) && Number(payload.gate?.version) > 0
export function buildProjectCommand(projectGuid, run, kind, clientRequestId) {
  if (!run.runGuid || !Number.isInteger(run.planVersion) || run.planVersion < 1 || !Number.isInteger(run.stateVersion) || run.stateVersion < 1)
    throw new Error('工作状态不完整，请刷新后操作')
  return { projectGuid, runGuid: run.runGuid, expectedPlanVersion: run.planVersion, expectedStateVersion: run.stateVersion, kind, clientRequestId }
}

// 主对话消息原位更新：游标补读可能重复，也可能晚于另一轮刷新返回。
export function mergeProjectMessages(current = [], incoming = []) {
  const messages = new Map(current.map(item => [item.messageGuid, item]))
  for (const item of incoming) {
    if (!item || typeof item.messageGuid !== 'string' || !Number.isFinite(Number(item.seq))) continue
    const old = messages.get(item.messageGuid)
    if (!old || Number(item.messageVersion || 1) >= Number(old.messageVersion || 1)) messages.set(item.messageGuid, item)
  }
  return [...messages.values()].sort((a, b) => Number(a.seq) - Number(b.seq))
}
